import classNames from 'classnames';
import { VideosNoConsentCard } from 'components/video-no-consent-card';
import { useUserCookieConsent } from 'hooks/use-user-cookie-consent';
import type { IntlKey } from 'locales';
import { FC, PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const StyledBackground = styled.div`
  background-color: var(--bs-royal-blue);
`;

export const Placeholder: FC<PropsWithChildren<{ className?: string; id: string }>> = ({ id, className, children }) => (
  <StyledBackground id={id} className={classNames('card', className)}>
    <div className="card-header"></div>
    <div className="card-body">{children}</div>
    <div className="card-footer"></div>
  </StyledBackground>
);

export function VideosNoConsent() {
  const { openCookiesConsent } = useUserCookieConsent();
  return <VideosNoConsentCard id="videos" className="py-5 px-4" openCookiesConsent={openCookiesConsent} />;
}

export function PublicationError({ id, errorKey }: { id: string; errorKey: IntlKey }) {
  return (
    <Placeholder id={id} className="bg-secondary bg-opacity-20">
      <h6 className="text-secondary">
        <FormattedMessage id={errorKey} />
      </h6>
    </Placeholder>
  );
}

export function PublicationEmpty({ id, soonKey }: { id: string; soonKey: IntlKey }) {
  return (
    <Placeholder id={id}>
      <h6 className="text-white">
        <FormattedMessage id={soonKey} />
      </h6>
    </Placeholder>
  );
}
